import React from 'react';
import loadImage from 'blueimp-load-image'

class Uploader extends React.Component {
    constructor(props) {
        super();

        this.input = React.createRef();
    }

    handleUpload = (e) => {
        const t = this;
        const p = t.props;
        const file = e.target.files[0];

        if (file) {
            loadImage(
                file, (canvas) => {
                    const base64 = canvas.toDataURL('image/jpeg');
                    p.onChange(p.inputName, base64);
                    t.input.current.value = null;
                },
                { maxWidth: 520,
                    maxHeight: 660,
                    canvas: true,
                orientation: true}
            );
        }
    };

    render() {
        const t = this;
        const p = t.props;

        return <input ref={t.input} id={p.id} type="file" onChange={t.handleUpload} accept={p.accept} />;
    }
}

export default Uploader;